import { render, staticRenderFns } from "./IconSession.vue?vue&type=template&id=6a971b19&"
import script from "./IconSession.vue?vue&type=script&lang=js&"
export * from "./IconSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a971b19')) {
      api.createRecord('6a971b19', component.options)
    } else {
      api.reload('6a971b19', component.options)
    }
    module.hot.accept("./IconSession.vue?vue&type=template&id=6a971b19&", function () {
      api.rerender('6a971b19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/IconSession.vue"
export default component.exports